import { useCCTM, useModel } from "@bcm-dev/bcms-vite";

export default function Nav(id) {
    // Converts an XML string into an XML DOM object
    function stringToXML(xmlString) {
        const parser = new DOMParser();
        return parser.parseFromString(xmlString, "application/xml");
    }

    // Converts an XML DOM object into a string
    function XMLToString(xmlString) {
        const serializer = new XMLSerializer();
        return serializer.serializeToString(xmlString);
    }

    const { user, branding, demos } = useModel();
    const bid = branding.options.bid_abi22;
    const xml = useCCTM();
    
    // Convert XML data into strings
    let abiXML = XMLToString(xml);
    let mabiXML = window.mabiMenu ? XMLToString(window.mabiMenu) : XMLToString(xml);

    // Convert the XML strings into XML DOM objects
    let abiNav = stringToXML(abiXML);
    let abiSideNav = abiNav.querySelector(`[id="sideNav"]`);
    let mabiSideNav = stringToXML(mabiXML).querySelector(`[id="sideNav"]`);

    // Check if the ID is 'sideNav', and apply the logic accordingly
    if (id === "sideNav" && abiSideNav && mabiSideNav) {
        function elementId(node) {
            return node && node.getAttribute ? (node.getAttribute("id") || "") : "";
        }

        // Recursively applies the callback function to each element in the XML structure.
        // Children are copied first. childNodes is live, so removing a node during
        // forEach skips the next sibling and leaves that extra item in the menu.
        function mapXMLElements(node, callback) {
            if (elementId(node) !== "sideNav") {
                callback(node);
            }

            if (!node.parentNode && elementId(node) !== "sideNav") {
                return;
            }

            const children = [];
            for (let i = 0; i < node.childNodes.length; i++) {
                if (node.childNodes[i].nodeType === 1) {
                    children.push(node.childNodes[i]);
                }
            }

            for (let i = 0; i < children.length; i++) {
                mapXMLElements(children[i], callback);
            }
        }

        // Removes a node from its parent if it exists
        function removeNode(node) {
            try {
                if (node && node.parentNode) {
                    node.parentNode.removeChild(node); // Remove the node from its parent
                } else {
                    console.warn(`Node with ID '${node.id}' not found.`); // If node not found, log a warning
                }
            } catch (e) {
                // Handle errors if any
            }
        }

        // Replaces the sideNav node with a new one
        function replaceNode(newNode) {
            try {
                // Replace the target node with the new node
                abiNav.querySelector(`[id="sideNav"]`).parentNode.replaceChild(
                    abiNav.importNode(newNode, true),
                    abiNav.querySelector(`[id="sideNav"]`)
                );
            } catch (e) {
                // Handle errors if any
                console.log(e);
            }
        }

        // Removes a MABI node only when it has an id that is not in the ABI sideNav.
        // Nodes with no id are left in place.
        const check = (node) => {
            const nodeId = elementId(node);
            if (nodeId && !abiSideNav.querySelector('[id="' + nodeId + '"]')) {
                removeNode(node);
            }
        };

        try {
            mapXMLElements(mabiSideNav, check);
            replaceNode(mabiSideNav);
        } catch (e) {
            // Handle errors during mapping
        }
    }

    // useEffect hook to trigger sideNav updates based on changes in abiNav
   

    return abiNav; // Return the modified abiNav (sideNav)
}
